import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag, Send } from "lucide-react";
import { useOrderList } from "@/context/OrderListContext";
import { formatPrice } from "@/lib/site";

// Mobil yapışkan alt çubuk: Sipariş Listem (X) · Tahmini Toplam · Sipariş adımlarını başlat.
export const MobileOrderBar = () => {
  const { count, total, isOpen, setIsOpen, openForCheckout } = useOrderList();

  return (
    <AnimatePresence>
      {count > 0 && !isOpen && (
        <motion.div
          initial={{ y: 90 }}
          animate={{ y: 0 }}
          exit={{ y: 90 }}
          transition={{ type: "spring", stiffness: 320, damping: 32 }}
          data-testid="mobile-order-bar"
          className="fixed inset-x-0 bottom-0 z-50 flex items-stretch border-t border-copper/30 bg-charcoal shadow-[0_-12px_30px_-12px_rgba(0,0,0,0.7)] lg:hidden"
        >
          <button
            data-testid="mobile-order-bar-open"
            onClick={() => setIsOpen(true)}
            className="flex flex-1 items-center gap-3 px-4 py-2.5 text-left"
          >
            <span className="relative flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-sm border border-copper/40 text-copper">
              <ShoppingBag className="h-5 w-5" />
              <span className="absolute -right-1.5 -top-1.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-bordo px-1 font-mono text-[10px] font-bold text-cream">
                {count}
              </span>
            </span>
            <span className="min-w-0">
              <span className="block font-mono text-[10px] uppercase tracking-wider text-cream/50">Sipariş Listem</span>
              <span data-testid="mobile-order-bar-total" className="block font-serif text-lg leading-tight text-cream">
                {total > 0 ? `≈ ${formatPrice(Math.round(total))}` : `${count} kalem`}
              </span>
            </span>
          </button>
          <button
            data-testid="mobile-order-bar-send"
            onClick={openForCheckout}
            className="flex items-center gap-2 bg-[#25D366] px-5 text-sm font-bold uppercase tracking-wide text-charcoal transition-colors hover:bg-[#1eb858]"
          >
            <Send className="h-5 w-5" /> Gönder
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MobileOrderBar;
